import React, { ImgHTMLAttributes } from 'react';

import type { WidgetPlugin } from '../../../types/widgetPlugins';

import s from './pluginsPanel.module.scss';
import { PluginFallbackLogo } from './svg/pluginFallbackLogo';

interface PluginLogoProps extends ImgHTMLAttributes<HTMLImageElement> {
  plugin: WidgetPlugin;
  fallbackLogoWidth?: string | number;
  fallbackLogoHeight?: string | number;
}

export const PluginLogo: React.FC<PluginLogoProps> = ({
  plugin,
  fallbackLogoWidth = 37,
  fallbackLogoHeight = 37,
  ...props
}) => {
  return plugin.logoUrl ? (
    <img
      alt={`${plugin.name} icon`}
      src={plugin.logoUrl}
      className={s.pluginIcon}
      {...props}
    />
  ) : (
    <PluginFallbackLogo width={fallbackLogoWidth} height={fallbackLogoHeight} />
  );
};
